import type { Lesson } from '../../schema.js';

export const MATE_IN_TWO_LESSONS: Lesson[] = [
  {
    id: 'puzzle-mate-in-2',
    slug: 'puzzles-mate-in-2',
    title: 'Mate in two',
    audienceLevel: 'beginner',
    concepts: ['puzzles'],
    steps: [
      {
        kind: 'explain',
        title: 'Two moves to victory',
        body: 'In these puzzles you make the first move, the enemy king must answer, and then you deliver checkmate. Look for a checking move that leaves the king only one escape — then cover it.',
        narration: 'Find the move that forces checkmate in two.',
      },
      {
        kind: 'drill',
        task: 'best-move',
        title: 'The b3 check',
        body: 'Check the king and then mate on b8.',
        fen: '6k1/6pp/8/8/8/6Q1/8/5RK1 w - - 0 1',
        answer: ['Qb3+'],
        solution: ['Qb3+', 'Kh8', 'Qb8#'],
        expect: 'mate',
        tier: 1,
        hint: 'First check the king along a diagonal.',
        hintLadder: ['First check the king along a diagonal.', 'Your rook covers the f8 escape.', 'Qb3+ forces Kh8, then Qb8 is checkmate!'],
      },
      {
        kind: 'drill',
        task: 'best-move',
        title: 'The c4 check',
        body: 'Check the king and then mate on c8.',
        fen: '6k1/6pp/8/8/7Q/8/8/5RK1 w - - 0 1',
        answer: ['Qc4+'],
        solution: ['Qc4+', 'Kh8', 'Qc8#'],
        expect: 'mate',
        tier: 2,
        hint: 'Check from a square that also eyes c8.',
        hintLadder: ['Check from a square that also eyes c8.', 'Your rook guards the f8 escape.', 'Qc4+ forces Kh8, then Qc8 is checkmate!'],
      },
      {
        kind: 'drill',
        task: 'best-move',
        title: 'Three ways to win',
        body: 'There is more than one good first move. Find any check that forces mate next move.',
        fen: '6k1/6pp/8/8/8/8/4Q3/4KR2 w - - 0 1',
        answer: ['Qc4+', 'Qe6+', 'Qa2+'],
        solution: ['Qe6+', 'Kh8', 'Qc8#'],
        expect: 'mate',
        tier: 3,
        hint: 'Your king and rook together cover many escapes.',
        hintLadder: ['Your king and rook together cover many escapes.', 'Check along a diagonal toward the 8th rank.', 'Qe6+ forces Kh8, then Qc8 is checkmate!'],
      },
    ],
  },
];
